const API_URL = process.env.REACT_APP_BACKEND_URL;

// Scarica il PDF Stazione Digitale personalizzato (QR della famiglia) via POST
export const downloadStazionePdf = async (famigliaId) => {
  const response = await fetch(`${API_URL}/api/stazione/generate-pdf/${famigliaId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  });

  if (!response.ok) {
    let detail = null;
    try {
      detail = (await response.json()).detail;
    } catch (parseError) {
      detail = null;
    }
    throw new Error(detail || `Errore nella generazione del PDF (${response.status})`);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'StazioneDigitale.pdf';
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const fetchStazioneStatus = async (famigliaId) => {
  const response = await fetch(`${API_URL}/api/stazione/status/${famigliaId}`);
  if (!response.ok) return {};
  return response.json();
};
